var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard vertical-center"},[_c('span',{staticClass:"welcome-msg"},[_vm._v(" 欢迎使用研和智能内部系统 ")])])
}]

export { render, staticRenderFns }